export default __webpack_public_path__ + "static/media/recruitment.49251e5b.png";